import { render, staticRenderFns } from "./VideoPlayer.vue?vue&type=template&id=7b983b38&"
import script from "./VideoPlayer.vue?vue&type=script&lang=ts&"
export * from "./VideoPlayer.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports